import React, { useContext } from "react";
import { queryCache, useMutation } from "react-query";

import { AssigneeSelector } from "fe-shared/src/components";
import { canAssignPortalUser } from "fe-shared-requests/src/helpers/pickupRequestStatus";
import { PickupRequestStatus } from "fe-shared-requests/src/types";

import UserContext from "contexts/userContext";
import { REQUESTS_QUERY_KEY, REQUEST_ACTIVITIES_QUERY_KEY } from "consts";

import * as api from "./modules/api";

interface Props {
  canAssign: boolean;
  requestNumber: string;
  status: PickupRequestStatus;
  assigneeId?: number;
  assigneeName?: string;
}

const PickupRequestAssigneeSelect = (props: Props) => {
  const { canAssign, requestNumber, status, assigneeId, assigneeName } = props;
  const { userId: currentUserId } = useContext(UserContext)!;

  const [assign] = useMutation(api.assignToPortalUser, {
    onSuccess: () => {
      queryCache.invalidateQueries(REQUESTS_QUERY_KEY);
      queryCache.invalidateQueries([
        REQUEST_ACTIVITIES_QUERY_KEY,
        requestNumber,
      ]);
    },
  });

  // Assigning from Submitted also moves the request to In Review; from In Review onwards it only swaps the assignee.
  const isAssignable = canAssign && canAssignPortalUser(status);

  const onChange = (portalUserId: string | number | null) => {
    if (portalUserId === null) {
      return;
    }

    assign({ requestNumber, portalUserId: Number(portalUserId) });
  };

  return (
    <AssigneeSelector
      entityId={requestNumber}
      isAssignable={isAssignable}
      isUnAssignable={false}
      loadOnlyActive
      isAssigned={!!assigneeId}
      currentUserId={currentUserId}
      assigneeId={assigneeId}
      assigneeName={assigneeName}
      onChange={onChange}
    />
  );
};

export default PickupRequestAssigneeSelect;
